module.exports = {
	siteName: 'home',
	site: {
		mancity: {
			appI18nConfig: {
				defaultLocale: 'en',
				supportedLocales: [
					'en',
					'ko',
					'fr',
					'ar',
					'pt',
					'es',
					'id',
					'th',
				],
			},
		},
	},
};
